import InputLabel from '@mui/material/InputLabel';
import React, { useState, useEffect } from 'react';
import AddressPart from './address-part';

interface Address {
  streetNumber?: string,
  streetName?: string,
  suite?: string,
  city?: string,
  county?: string,
  state?: string,
  postalCode?: string,
  country?: string,
}

interface Props {
  hidden?: boolean,
  value?: { address: Address },
  disabled?: boolean,
  onChange?: (newVal: { address: Address }) => void,
  useApiPartKeys?: boolean,
}

const AddressField: React.FC<Props> = ({
  hidden = false,
  value,
  disabled = false,
  onChange,
  useApiPartKeys = false,
}: Props) => {
  const address = value || { address: {} };
  const [addressValue, setValue] = useState(address);
  const handleChange = (partKey: string, partValue: string) => {
    addressValue.address[partKey] = partValue;
    if (onChange && !disabled) {
      onChange(addressValue);
    }
    setValue(addressValue);
  };

  const renderPart = (partName: string, altName: string, placeholder: string) => (
    <AddressPart
      part={useApiPartKeys ? altName : partName}
      value={addressValue.address[partName] || addressValue.address[altName] || ''}
      placeholder={placeholder}
      onChange={handleChange}
      disabled={disabled}
    />
  );

  return (
    <>
      {!hidden
        && (
          <>
            <InputLabel>Address</InputLabel>
            {renderPart('streetNumber', 'sub_thoroughfare', 'Street Number')}
            {renderPart('streetName', 'thoroughfare', 'Street Name')}
            {renderPart('suite', 'suite', 'Apartment / Suite')}
            {renderPart('city', 'locality', 'City')}
            {renderPart('county', 'sub_admin_area', 'County')}
            {renderPart('state', 'admin_area', 'State')}
            {renderPart('postalCode', 'postal_code', 'Postal Code')}
            {renderPart('country', 'country', 'Country')}
          </>
        )}
    </>
  );
};

export default AddressField;
